import { Link } from "react-router-dom";
import ProfilePreview from "../../UserInterface/ProfilePreview";
import { Heading } from "../../Type";
import styles from "./profileCell.module.scss";
import { UserType } from "../../../types/userType";

const ProfileCell = ({
  data,
  admin = false,
  link = false,
}: {
  data: UserType[];
  admin?: boolean;
  link?: boolean;
}) => {
  if (!data.length) {
    return (
      <Heading size="h5" className={styles.unassigned}>
        Unassigned
      </Heading>
    );
  }

  return (
    <>
      {data.map((a) => {
        if (!link)
          return (
            <div key={a.id} className={styles.profile}>
              <ProfilePreview key={a.id} size="small" user={a} />
            </div>
          );
        return (
          <Link
            to={`${admin ? "/admin/" : "/"}user/${a.id}`}
            key={a.id}
            className={styles.profileLink}
          >
            <ProfilePreview key={a.id} size="small" user={a} />
          </Link>
        );
      })}
    </>
  );
};

export default ProfileCell;
